// extracted by mini-css-extract-plugin
export var numpadContainer = "_r0-1";
export var phoneButton = "_r0-0";